import { render, staticRenderFns } from "./sglMain.vue?vue&type=template&id=75c79dca&scoped=true&"
import script from "./sglMain.vue?vue&type=script&lang=js&"
export * from "./sglMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c79dca",
  null
  
)

export default component.exports